/**
 * Development environment configuration
 */
export const environment = {
  production: false,
  apiUrl: 'https://api.dev.cuanone.com/api',
  apiBaseUrl: 'https://api.dev.cuanone.com',
  appName: 'Marina Admin Portal (Dev)',
  appVersion: '1.0.0-dev',
  enableDebug: true,
  enableLogging: true,
  logLevel: 'debug',
  /**
   * QA has no physical readers yet — use Stripe JS simulated reader.
   * Flip to false when real Terminal hardware is available on Dev.
   */
  /** Auto-presented by the simulated reader (no browser card UI). */
  features: {
    enableNotifications: true,
    enablePayments: true,
    enableDocuments: true,
    enableReports: true,
    enableCompliance: true,
  },
  storage: {
    tokenKey: 'marina_admin_token',
    refreshTokenKey: 'marina_admin_refresh_token',
    userKey: 'marina_admin_user',
  },
  pagination: {
    defaultPageSize: 20,
    pageSizeOptions: [10, 20, 50, 100],
  },
  dateFormat: 'MM/DD/YYYY',
  currency: 'USD',
  locale: 'en-US',
};
